import styled from 'styled-components';
import {
	BaseStyledComponentProps,
	navBarButtonWrapperStyle,
	navBarIconStyle,
} from '../../../../utils/styles-constants';

interface StyledSearchButtonProps extends BaseStyledComponentProps {
	isActive: boolean;
}

const SearchButtonContainer = styled('div')`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
`;

const StyledSearchButton = styled('button')`
	cursor: pointer;
	${navBarButtonWrapperStyle}
	padding: 4px 1px 2px;
	border-color: transparent;
	background-color: transparent;
	box-sizing: border-box;
	transition: .1s ease-in-out;
	transition-property: opacity, border-color;

	&:focus {
		outline: 0;
	}

	& > svg {
		${navBarIconStyle}
		fill: ${(props: StyledSearchButtonProps) => props.isActive
			? props.theme.primary.actionColor
			: props.theme.primary.iconsColor
		};
	}

	&:active {
		opacity: 0.3;
	}
`;

export { SearchButtonContainer, StyledSearchButton };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/Button/styles.ts